export default {"src":"/_next/static/media/testing-and-validation.dae477c5.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};